import { z } from 'zod';
import { ZodError } from 'zod-validation-error';

const stringConstraints = (message: string) =>
  z.string().refine((val) => val.length > 0, {
    message,
  });

type TextAreaMaxLengthSchemaType = {
  fieldNames: string[];
  maxLength: number;
};

export const yourDetailsSchema = z.object({
  firstName: stringConstraints('Enter a first name'),
  lastName: stringConstraints('Enter a last name'),
  email: z.string().email('Enter a valid email address'),
});

export const addressResultSchema = z.object({
  addressSearch: z
    .array(z.any())
    .nonempty('No address found. Please try again.'),
});

export const parseZodErrors = (error: ZodError) => {
  return error.errors.map((err) => ({
    path: err.path[0] as string,
    message: err.message,
  }));
};

export const binaryQuestionSchema = () =>
  z.object({
    receiveConfirmationEmail: z.string().refine(
      (val) => {
        return val.length > 0;
      },
      {
        message: 'Select an option',
      },
    ),
  });

export const locationValidation = z.object({
  locationOfWaste: z.string().refine((val) => val.length > 0, {
    message: 'Please select a location on the map',
  }),
});

export const wasteCurrentSubcategory = z.object({
  subcategoryName: z.string().refine((val) => val.length > 0, {
    message: 'Select a category to continue',
  }),
});
export const inferCategoryValidation = z.object({
  infercategoryName: z.string().refine((val) => val.length > 0, {
    message: 'Select a category to continue',
  }),
});

export const validateDynamicFields = (fieldName: string, response: string) => {
  return z.object({
    [fieldName]: z.string().refine(
      () => {
        return response.length > 0;
      },
      {
        message: 'Select an option to continue',
      },
    ),
  });
};
export const TextAreaMaxLengthSchema = ({
  fieldNames,
  maxLength,
}: TextAreaMaxLengthSchemaType) => {
  const textAreaValidation = fieldNames.reduce(
    (rest, fieldName) => ({
      ...rest,
      [fieldName]: z.string().refine(
        (val) => {
          return val.length <= maxLength;
        },
        {
          message: 'Field must be 500 characters or less',
        },
      ),
    }),
    {},
  );
  return z.object(textAreaValidation);
};

export type TextAreaFlexibleLengthSchemaType = {
  fieldNames: string[];
  minLength?: number;
  maxLength: number;
};

export const TextAreaFlexibleLengthSchema = ({
  fieldNames,
  minLength,
  maxLength,
}: TextAreaFlexibleLengthSchemaType) => {
  const textAreaValidation = fieldNames.reduce(
    (rest, fieldName) => ({
      ...rest,
      [fieldName]: z
        .string()
        .min(
          minLength || 1,
          minLength
            ? `Field must be at least ${minLength} characters`
            : 'This field is required',
        )
        .max(maxLength, `Field must be ${maxLength} characters or less`),
    }),
    {},
  );
  return z.object(textAreaValidation);
};
